import gql from 'graphql-tag'
import client from 'lib/graphql'
import { MFA_STATUS_QUERY } from './status'

export const SETUP_TOTP_MUTATION = gql`
  mutation app__MfaSetupTotp {
    setupTotp {
      userId
      secret
      qrCode
      recoveryCode
      errors {
        field
        message
      }
    }
  }
`

export const VERIFY_TOTP_QUERY = gql`
  query app__MfaVerifyTotp($input: VerifyTotpInput!) {
    verifyTotp(input: $input) {
      userId
      success
      errors {
        message
        field
      }
    }
  }
`

export const DISABLE_TOTP_MUTATION = gql`
  mutation app__MfaDisableTotp($input: DisableTotpInput!) {
    disableTotp(input: $input) {
      userId
      errors {
        message
      }
    }
  }
`

type DisableTotpMutation = DisableTotpPayload | null

interface DisableTotpPayload {
  userId: string | null
  errors: ValidationError[] | null
}

interface ValidationError {
  message: string
}

export async function disableTotp(password: string): Promise<DisableTotpMutation> {
  const { data } = await client.mutate({
    mutation: DISABLE_TOTP_MUTATION,
    variables: {
      input: {
        password
      }
    },
    refetchQueries: [{ query: MFA_STATUS_QUERY }]
  })

  return data.disableTotp
}
